import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('App crashed:', error, info?.componentStack);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: '24px', fontFamily: 'system-ui, sans-serif' }}>
                    <h2 style={{ color: '#b91c1c' }}>Something went wrong.</h2>
                    <pre style={{ whiteSpace: 'pre-wrap', background: '#fef2f2', padding: '12px', borderRadius: '8px', color: '#7f1d1d' }}>
                        {String(this.state.error?.message || this.state.error)}
                    </pre>
                    <button
                        onClick={() => { this.setState({ error: null }); window.location.href = '/login'; }}
                        style={{ marginTop: '12px', padding: '8px 16px', background: '#0069d9', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                    >
                        Return to login
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
